// extracted by mini-css-extract-plugin
export default {"container":"NewClinicScreen_container__Dgdfk"};